import { FUTUREBILITY_COCKPIT_URL } from "../constants";
import { CubeSideName } from "./components/Сube/types";

export const CUBE_COCKPIT_URL_PATTERN = `${FUTUREBILITY_COCKPIT_URL}/:clientId/:testId`;

export const CUBE_SIDES_NAV_ROUTES: CubeSideName[] = [
  "1",
  "5",
  "2",
  "3",
  "6",
  "4",
];

export enum SortOrder {
  ASC = "asc",
  DESC = "desc",
  ORIGINAL = "original",
}

export const MIN_REPLIES_FOR_AI_GENERATION = 2;
